<template>
	<section class="container-multiBlock" :id="[index]">
		<div class="container">
			<div class="row">
				<h2>{{ multiData.config.title }}</h2>
				<template v-for="(section, name, index) in multiData.config" :key="index">
					<div class="col-lg-6">
						<TextComponent :textData="section" v-if="section.type == 'text'" isMultiblock="true" />
						<GalleryComponent :pictureData="section" v-else-if="section.type == 'pictures'" isMultiblock="true" />
						<FactsComponent :factsData="section" v-else-if="section.type == 'data'" isMultiblock="true" />
						<FreetextComponent :freetextData="section" v-else-if="section.type == 'freetext'" isMultiblock="true" />
					</div>
				</template>
			</div>
		</div>
	</section>
</template>


<script>
import TextComponent from "./TextComponent.vue";
import GalleryComponent from "./GalleryComponent.vue";
import FactsComponent from "./FactsComponent.vue";
import FreetextComponent from "./FreetextComponent.vue";

export default {
	components: {
		TextComponent,
		GalleryComponent,
		FreetextComponent,
		FactsComponent
	},

	props: {
		multiData: {
			type: Object,
		},
		pictureData: {
			type: Object
		},
		index: {
			type: Number,
		},
		isMultiblock: {
			type: String
		}
	},
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/design-wien/locationComponent.scss";
</style>
